import PropTypes from "prop-types";
import React from "react";
import Icon from "./Icon";
import "./LikeButton.css";

const LikeButton = props => {
	const { liked, size, onClick } = props;

	return (
		<button
			className={`LikeButton LikeButton-${liked ? "liked" : "notLiked"}`}
			{...(size ? { style: { width: size, height: size } } : {})}
			type="button"
			onClick={onClick}
		>
			<Icon shape="thumbs-up" />
		</button>
	);
};

LikeButton.propTypes = {
	liked: PropTypes.bool,
	size: PropTypes.number
};

LikeButton.defaultProps = {
	liked: false,
	size: 30
};

export default LikeButton;
